/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Icon from '@salesforce/design-system-react/components/icon';
import { useQuery } from '@apollo/react-hooks';
import { ATTACHMENT_TYPE } from '../../../../../../../util/constants';
import { GET_SAS_URI } from '../../../../../../../graphql/getSasUri';
import { formatTimestamp } from '../../../../../../../util/utilityFunctions';

interface Item {
  name?: string;
  imageurl?: string;
}

interface Props {
  children?: FC;
  item?: Item;
  indicator: string;
  poAttachmentTimestamp?: string;
}

const CustomeDataCell: FC<Props> = ({
  item = {},
  indicator = '',
  poAttachmentTimestamp,
}) => {
  const { data: sasUriData } = useQuery(GET_SAS_URI);
  const { name, imageurl } = item;
  const openAttachment = (): void => {
    const attachmentUrl = `${imageurl}?${sasUriData?.getSasUri.sasUri}`;
    window.open(attachmentUrl, '_blank');
  };
  return (
    <DataTableCell>
      <IconSettings iconPath="/icons">
        {indicator === 'ATTACHMENT' ? (
          <div
            aria-hidden="true"
            data-testid="attachment-file-name"
            onKeyDown={openAttachment}
            onClick={openAttachment}
            style={{ padding: '0px 5px' }}
          >
            {name}
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>            
            {indicator === ATTACHMENT_TYPE.PO && poAttachmentTimestamp && (
              <span data-testid="attachment-po-timestamp" style={{ fontSize: '0.75rem', color: '#3e3e3c' }}>
                {formatTimestamp(poAttachmentTimestamp)}
              </span>
            )}
          </div>
        )}
      </IconSettings>
    </DataTableCell>
  );
};

CustomeDataCell.displayName = DataTableCell.displayName;

export default CustomeDataCell;
